import Promise from '../lib/Promise.js';

function run({env}) {
    if (!env.getUrlParams().hasConfirmUsername()) {
        return Promise.resolve();
    }

    env.getProxy().confirmEmail({key: env.getUrlParams().getConfirmUsername()})
        .then(() => env.showDialog('change-username-success-dialog'))
        .catch(error => {
            if (error.hasType('UnknownUsernameConfirmationKey')) {
                env.showDialog('change-username-failure-dialog');
                return;
            }

            throw error;
        });

    return Promise.inert();
}

export default {run};